import { AuthUser, TAwaitingApprovalTable } from '@src/types';

export const awaitingApprovalData: TAwaitingApprovalTable[] = [
  {
    id: '1',
    memberId: 'LL783278632',
    accountId: 'LE-LL0087623123-144',
    package: 'Leeloo Entry Level LE 15 Contract | $150,000 Cruise ',
    traderPaid: 159056,
    leelooPaid: 23455,
    activePa: 3,
    flagged: true,
    trading: '10',
    balance: '$159,056',
    balanceAt: new Date().toISOString(),
    createdAt: '2025-04-13T10:37:47.780Z',
    status: `Account (with addon) reached qualifying balance on 05 mae 2025`,
    user: {
      id: '1',
      username: 'John Doe',
      email: 'john_doe@gmail.com',
    } as unknown as AuthUser,
  },
  {
    id: '2',
    memberId: 'LL783278632',
    user: {
      id: '1',
      username: 'John Doe',
      email: 'john_doe@gmail.com',
    } as unknown as AuthUser,
    accountId: 'LE-LL0087623123-144',
    traderPaid: 159056,
    leelooPaid: 23455,
    activePa: 3,
    flagged: true,
    package: 'Leeloo Entry Level LE 15 Contract | $150,000 Cruise ',
    trading: '10',
    balance: '$159,056',
    balanceAt: new Date().toISOString(),
    createdAt: '2025-04-13T10:37:47.780Z',
    status: `Account (with addon) reached qualifying balance on 05 mae 2025`,
  },
  {
    id: '3',
    memberId: 'LL783278632',
    user: {
      id: '1',
      username: 'John Doe',
      email: 'john_doe@gmail.com',
    } as unknown as AuthUser,
    accountId: 'LE-LL0087623123-144',
    traderPaid: 159056,
    leelooPaid: 23455,
    activePa: 3,
    flagged: true,
    package: 'Leeloo Entry Level LE 15 Contract | $150,000 Cruise ',
    trading: '10',
    balance: '$159,056',
    balanceAt: new Date().toISOString(),
    createdAt: '2025-04-13T10:37:47.780Z',
    status: `Account (with addon) reached qualifying balance on 05 mae 2025`,
  },
  {
    id: '4',
    memberId: 'LL783278632',
    user: {
      id: '1',
      username: 'John Doe',
      email: 'john_doe@gmail.com',
    } as unknown as AuthUser,
    accountId: 'LE-LL0087623123-144',
    traderPaid: 159056,
    leelooPaid: 23455,
    activePa: 3,
    flagged: true,
    package: 'Leeloo Entry Level LE 15 Contract | $150,000 Cruise ',
    trading: '10',
    balance: '$159,056',
    balanceAt: new Date().toISOString(),
    createdAt: '2025-04-13T10:37:47.780Z',
    status: `Account (with addon) reached qualifying balance on 05 mae 2025`,
  },
  {
    id: '5',
    memberId: 'LL783278632',
    user: {
      id: '1',
      username: 'John Doe',
      email: 'john_doe@gmail.com',
    } as unknown as AuthUser,
    accountId: 'LE-LL0087623123-144',
    traderPaid: 159056,
    leelooPaid: 23455,
    activePa: 3,
    flagged: true,
    package: 'Leeloo Entry Level LE 15 Contract | $150,000 Cruise ',
    trading: '10',
    balance: '$159,056',
    balanceAt: new Date().toISOString(),
    createdAt: '2025-04-13T10:37:47.780Z',
    status: `Account (with addon) reached qualifying balance on 05 mae 2025`,
  },
];

export const pendingPerformanceAccountsData: TAwaitingApprovalTable[] = [
  {
    id: '1',
    memberId: 'LL783278632',
    accountId: 'LE-LL0087623123-144',
    package: 'Performance Account Purchase',
    productName: '-',
    trading: '10',
    balance: '$159,056',
    balanceAt: new Date().toISOString(),
    createdAt: '2025-04-13T10:37:47.780Z',
    updatedAt: '2025-04-13T10:37:47.780Z',
    status: `No approved EVAL(s), Check user details`,
    aMemberInvoice: '855767/0D5X5',
    from: '2025-04-13T10:37:47.780Z',
    to: '2025-04-16T10:37:47.780Z',
    user: {
      id: '1',
      username: 'John Doe',
      email: 'john_doe@gmail.com',
    } as unknown as AuthUser,
  },
  {
    id: '2',
    memberId: 'LL783278632',
    user: {
      id: '1',
      username: 'John Doe',
      email: 'john_doe@gmail.com',
    } as unknown as AuthUser,
    accountId: 'LE-LL0087623123-144',
    package: 'Performance Account Purchase',
    trading: '10',
    balance: '$159,056',
    from: '2025-04-13T10:37:47.780Z',
    to: '2025-04-16T10:37:47.780Z',
    balanceAt: new Date().toISOString(),
    createdAt: '2025-04-13T10:37:47.780Z',
    updatedAt: '2025-04-13T10:37:47.780Z',
    status: `No approved EVAL(s), Check user details`,
    aMemberInvoice: '855767/0D5X5',
  },
  {
    id: '3',
    memberId: 'LL783278632',
    user: {
      id: '1',
      username: 'John Doe',
      email: 'john_doe@gmail.com',
    } as unknown as AuthUser,
    accountId: 'LE-LL0087623123-144',
    package: 'Performance Account Purchase',
    trading: '10',
    from: '2025-04-13T10:37:47.780Z',
    to: '2025-04-16T10:37:47.780Z',
    balance: '$159,056',
    balanceAt: new Date().toISOString(),
    createdAt: '2025-04-13T10:37:47.780Z',
    updatedAt: '2025-04-13T10:37:47.780Z',
    status: `No approved EVAL(s), Check user details`,
    aMemberInvoice: '855767/0D5X5',
  },
  {
    id: '4',
    memberId: 'LL783278632',
    user: {
      id: '1',
      username: 'John Doe',
      email: 'john_doe@gmail.com',
    } as unknown as AuthUser,
    accountId: 'LE-LL0087623123-144',
    package: 'Performance Account Purchase',
    trading: '10',
    from: '2025-04-13T10:37:47.780Z',
    to: '2025-04-16T10:37:47.780Z',
    balance: '$159,056',
    balanceAt: new Date().toISOString(),
    createdAt: '2025-04-13T10:37:47.780Z',
    updatedAt: '2025-04-13T10:37:47.780Z',
    status: `No approved EVAL(s), Check user details`,
    aMemberInvoice: '855767/0D5X5',
  },
  {
    id: '5',
    memberId: 'LL783278632',
    user: {
      id: '1',
      username: 'John Doe',
      email: 'john_doe@gmail.com',
    } as unknown as AuthUser,
    accountId: 'LE-LL0087623123-144',
    package: 'Performance Account Purchase',
    trading: '10',
    from: '2025-04-13T10:37:47.780Z',
    to: '2025-04-16T10:37:47.780Z',
    balance: '$159,056',
    balanceAt: new Date().toISOString(),
    createdAt: '2025-04-13T10:37:47.780Z',
    updatedAt: '2025-04-13T10:37:47.780Z',
    status: `No approved EVAL(s), Check user details`,
    aMemberInvoice: '855767/0D5X5',
  },
];
